import script from "./meeting-proposal-finalizing-overlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./meeting-proposal-finalizing-overlay.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__